<template>
  <div class="we-circular-page">
    <WeCircularNavbar @go-home="goHome" @go-countries="goCountries" />

    <div id="countries-map" v-if="!selectedCountry">
      <CountryMapSection @select-country="handleCountrySelection" />
    </div>

    <CountryDetail v-else :country="selectedCountry" @back="clearSelectedCountry" />

    <WeCircularFooter />
  </div>
</template>

<script>
import WeCircularNavbar from './WeCircularNavbar.vue'
import WeCircularFooter from './WeCircularFooter.vue'
import CountryMapSection from './CountryMapSection.vue'
import CountryDetail from './CountryDetail.vue'

export default {
  name: 'WeCircularMain',
  components: {
    CountryMapSection,
    CountryDetail,
    WeCircularNavbar,
    WeCircularFooter
  },
  data() {
    return {
      selectedCountry: null
    }
  },
  mounted() {
    this.selectCountryFromRoute()
  },
  watch: {
    '$route.query.country'() {
      this.selectCountryFromRoute()
    },
    '$route.hash'() {
      this.selectCountryFromRoute()
    }
  },
  methods: {
    selectCountryFromRoute() {
      const countryName = this.$route.query.country

      if (!countryName) {
        return
      }

      const savedCountry = sessionStorage.getItem('weCircularSelectedCountry')

      if (!savedCountry) {
        return
      }

      const parsedCountry = JSON.parse(savedCountry)

      if (parsedCountry.name === countryName) {
        this.selectedCountry = parsedCountry

        this.$nextTick(() => {
          if (this.$route.hash) {
            const el = document.querySelector(this.$route.hash)

            if (el) {
              el.scrollIntoView({
                behavior: 'smooth',
                block: 'start'
              })
              return
            }
          }

          window.scrollTo({
            top: 0,
            behavior: 'smooth'
          })
        })
      }
    },

    clearSelectedCountry() {
      this.selectedCountry = null
      sessionStorage.removeItem('weCircularSelectedCountry')
      this.$router.push('/we-circular')
    },

    goHome() {
      this.selectedCountry = null
      sessionStorage.removeItem('weCircularSelectedCountry')
      this.$router.push('/we-circular')

      this.$nextTick(() => {
        window.scrollTo({
          top: 0,
          behavior: 'smooth'
        })
      })
    },

    goCountries() {
      this.selectedCountry = null
      sessionStorage.removeItem('weCircularSelectedCountry')
      this.$router.push('/we-circular')

      this.$nextTick(() => {
        setTimeout(() => {
          const el = document.querySelector('#countries-map')
          if (el) {
            el.scrollIntoView({
              behavior: 'smooth',
              block: 'start'
            })
          }
        }, 50)
      })
    },

    handleCountrySelection(countryData) {
      this.selectedCountry = countryData

      sessionStorage.setItem('weCircularSelectedCountry', JSON.stringify(countryData))

      this.$router.push({
        path: '/we-circular',
        query: {
          country: countryData.name
        }
      })

      window.scrollTo({
        top: 0,
        behavior: 'smooth'
      })
    }
  }
}
</script>

<style scoped>
.we-circular-page {
  width: 100%;
}
</style>
